import React, { useState,useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { ApiUrl } from "../../../ApiUrl";

const App = ({ goToTab, languageData, setExperienceDataInParent }) => {
  const [selectedLanguages, setSelectedLanguages] = useState([]);

  const languages = [
  "HINDI",
  "ENGLISH",
  "BENGALI",
  "MARATHI",
  "TELUGU",
  "TAMIL",
  "GUJARATI",
  "URDU",
  "KANNADA",
  "ODIA",
  "MALAYALAM",
  "PUNJABI",
  "ASSAMESE",
  "MAITHILI",
  "SANTALI",
  "KASHMIRI",
  "SANSKRIT",
  "OTHERS",
];
  // Mapping language to code dynamically
  const languageCodes = {
  HINDI: "1",
  ENGLISH: "2",
  BENGALI: "3",
  MARATHI: "4",
  TELUGU: "5",
  TAMIL: "6",
  GUJARATI: "7",
  URDU: "8",
  KANNADA: "9",
  ODIA: "10",
  MALAYALAM: "11",
  PUNJABI: "12",
  ASSAMESE: "13",
  MAITHILI: "14",
  SANTALI: "15",
  KASHMIRI: "16",
  SANSKRIT: "17",
  OTHERS: "18",
};

  const codeToLanguage = Object.entries(languageCodes).reduce((acc, [name, code]) => {
    acc[String(code)] = name;
    return acc;
  }, {});

  const normalizeLanguageEntry = (entry) => {
    if (entry === undefined || entry === null) {
      return null;
    }

    const raw = String(entry).trim();
    if (!raw) {
      return null;
    }

    const upperRaw = raw.toUpperCase();
    if (languageCodes[upperRaw]) {
      return upperRaw;
    }

    const mapped = codeToLanguage[raw];
    return mapped || null;
  };

  const handleLanguageClick = (language) => {
  if (selectedLanguages.includes(language)) {
    setSelectedLanguages(
      selectedLanguages.filter((item) => item !== language)
    );
  } else {
    setSelectedLanguages([...selectedLanguages, language]);
  }
};


  useEffect(() => {
    const preselected = [];

    if (languageData) {
      const directCode = normalizeLanguageEntry(languageData.language_code);
      if (directCode) {
        preselected.push(directCode);
      }

      if (Array.isArray(languageData.language_codes)) {
        languageData.language_codes.forEach((code) => {
          const normalized = normalizeLanguageEntry(code);
          if (normalized) {
            preselected.push(normalized);
          }
        });
      }
    }

    const sessionRaw = sessionStorage.getItem("staff_registration_language");
    if (sessionRaw) {
      try {
        const parsed = JSON.parse(sessionRaw);
        if (parsed && typeof parsed === "object") {
          const sessionDirect = normalizeLanguageEntry(parsed.language_code);
          if (sessionDirect) {
            preselected.push(sessionDirect);
          }

          if (Array.isArray(parsed.language_codes)) {
            parsed.language_codes.forEach((code) => {
              const normalized = normalizeLanguageEntry(code);
              if (normalized) {
                preselected.push(normalized);
              }
            });
          }
        }
      } catch (error) {
        console.warn("Unable to parse saved language draft", error);
      }
    }

    if (preselected.length) {
      setSelectedLanguages(Array.from(new Set(preselected)));
    }
  }, [languageData]);

  // const handleNextClick = async () => {
  //   if (!selectedLanguage) {
  //     alert("Please select a language before proceeding.");
  //     return;
  //   }

  //   const employeeId = localStorage.getItem("employeeId");
  //   const createdBy = sessionStorage.getItem("userId");

  //   const payload = {
  //     employee_language_id: 0, // adjust if needed dynamically
  //     language_code: languageCodes[selectedLanguage], // get code based on selected language
  //     created_by: parseInt(createdBy),
  //   };

  //   try {
  //     const response = await fetch(
  //       `${ApiUrl.apiurl}STAFF/registrationLANGUAGECreateUpdate/${employeeId}/`,
  //       {
  //         method: "PUT",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(payload),
  //       }
  //     );

  //     if (response.ok) {
  //       const data = await response.json();
  //       console.log("Language API Response:", data);
  //       alert("Language saved successfully!");
  //       goToTab(7); // Move to next tab only after successful API call
  //     } else {
  //       const errorData = await response.json();
  //       console.error("Language API Error:", errorData);
  //       alert("Failed to save language.");
  //     }
  //   } catch (error) {
  //     console.error("Network Error:", error);
  //     alert("Network error occurred.");
  //   }
  // };

  const handleNextClick = () => {
  if (selectedLanguages.length === 0) {
    alert("Please select at least one language.");
    return;
  }

  const createdBy = sessionStorage.getItem("userId") || "0";

  const languagePayload = {
    employee_language_id: 0,
    language_code: languageCodes[selectedLanguages[0]],
    language_codes: selectedLanguages.map((lang) => languageCodes[lang]),
    created_by: parseInt(createdBy),
  };

  sessionStorage.setItem(
    "staff_registration_language",
    JSON.stringify(languagePayload)
  );

  goToTab(7);
};

  useEffect(() => {
    const createdBy = sessionStorage.getItem("userId") || "0";

    if (selectedLanguages.length === 0) {
      sessionStorage.setItem("staff_registration_language", JSON.stringify({}));
      return;
    }

    const languagePayload = {
      employee_language_id: 0,
      language_code: languageCodes[selectedLanguages[0]],
      language_codes: selectedLanguages.map(
  (lang) => languageCodes[lang]
),
      created_by: parseInt(createdBy),
    };

    sessionStorage.setItem(
      "staff_registration_language",
      JSON.stringify(languagePayload)
    );
  }, [selectedLanguages]);

  return (
    <div className="container-fluid my-4">
      <div
        style={{
          maxHeight: "500px",
          overflowY: "auto",
          width: "100%", // Increased width to 100%
          border: "1px solid black",
        }}
      >
        <ul className="list-group">
          {languages.map((language, index) => (
            <li
              key={index}
              className={`list-group-item ${
                selectedLanguages.includes(language)
  ? "active text-white"
  : ""
              }`}
              style={{ cursor: "pointer" }}
              onClick={() => handleLanguageClick(language)}
            >
              {language}
            </li>
          ))}
        </ul>
      </div>

      <div className="d-flex justify-content-between mb-3 mt-3"></div>

      {selectedLanguages.length > 0 && (
  <div className="mt-3">
    <strong>Selected Languages:</strong>{" "}
    {selectedLanguages.join(", ")}
  </div>
)}
      
    </div>
  );
};

export default App;
